module.exports = __webpack_public_path__ + "media/images/menu-c994067084aaefaed051f901437261c4.svg";